/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankruptcyCapabilityResponse } from './BankruptcyCapabilityResponse';
import {
    BankruptcyCapabilityResponseFromJSON,
    BankruptcyCapabilityResponseFromJSONTyped,
    BankruptcyCapabilityResponseToJSON,
    BankruptcyCapabilityResponseToJSONTyped,
} from './BankruptcyCapabilityResponse';

/**
 * 
 * @export
 * @interface BankruptcyChecklistResponse
 */
export interface BankruptcyChecklistResponse {
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasRentArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasUtilityArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasOpenPenalties: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasInstallmentAgreement: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    canMeetInstallmentAgreement: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasChildrenWithMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    paysFullMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isMaintenanceGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    wasPreviouslySelfEmployed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isCurrentlySelfEmployed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasBusinessLicense: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    exercisesTradeAsBusiness: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isBusinessLicenseDormant: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasMaintenanceArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasCriminalDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasCreditDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    creditWithinLastFiveYears: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    creditRemark: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasMailOrderDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    mailOrderWithinLastThreeYears: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    mailOrderRemark: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasNeverPaidDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasOwnCheckingAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isCheckingAccountOverdrawn: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasRegisteredMobilePhone: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isElectricityInOwnName: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isApartmentDistrictHeated: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isDistrictHeatingInOwnName: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof BankruptcyChecklistResponse
     */
    lastChangedAtUtc: Date | null;
    /**
     * 
     * @type {BankruptcyCapabilityResponse}
     * @memberof BankruptcyChecklistResponse
     */
    bankruptcyCapability: BankruptcyCapabilityResponse;
}

/**
 * Check if a given object implements the BankruptcyChecklistResponse interface.
 */
export function instanceOfBankruptcyChecklistResponse(value: object): value is BankruptcyChecklistResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('hasRentArrears' in value) || value['hasRentArrears'] === undefined) return false;
    if (!('hasUtilityArrears' in value) || value['hasUtilityArrears'] === undefined) return false;
    if (!('hasOpenPenalties' in value) || value['hasOpenPenalties'] === undefined) return false;
    if (!('hasInstallmentAgreement' in value) || value['hasInstallmentAgreement'] === undefined) return false;
    if (!('canMeetInstallmentAgreement' in value) || value['canMeetInstallmentAgreement'] === undefined) return false;
    if (!('hasChildrenWithMaintenance' in value) || value['hasChildrenWithMaintenance'] === undefined) return false;
    if (!('paysFullMaintenance' in value) || value['paysFullMaintenance'] === undefined) return false;
    if (!('isMaintenanceGarnished' in value) || value['isMaintenanceGarnished'] === undefined) return false;
    if (!('wasPreviouslySelfEmployed' in value) || value['wasPreviouslySelfEmployed'] === undefined) return false;
    if (!('isCurrentlySelfEmployed' in value) || value['isCurrentlySelfEmployed'] === undefined) return false;
    if (!('hasBusinessLicense' in value) || value['hasBusinessLicense'] === undefined) return false;
    if (!('exercisesTradeAsBusiness' in value) || value['exercisesTradeAsBusiness'] === undefined) return false;
    if (!('isBusinessLicenseDormant' in value) || value['isBusinessLicenseDormant'] === undefined) return false;
    if (!('hasMaintenanceArrears' in value) || value['hasMaintenanceArrears'] === undefined) return false;
    if (!('hasCriminalDebts' in value) || value['hasCriminalDebts'] === undefined) return false;
    if (!('hasCreditDebts' in value) || value['hasCreditDebts'] === undefined) return false;
    if (!('creditWithinLastFiveYears' in value) || value['creditWithinLastFiveYears'] === undefined) return false;
    if (!('creditRemark' in value) || value['creditRemark'] === undefined) return false;
    if (!('hasMailOrderDebts' in value) || value['hasMailOrderDebts'] === undefined) return false;
    if (!('mailOrderWithinLastThreeYears' in value) || value['mailOrderWithinLastThreeYears'] === undefined) return false;
    if (!('mailOrderRemark' in value) || value['mailOrderRemark'] === undefined) return false;
    if (!('hasNeverPaidDebts' in value) || value['hasNeverPaidDebts'] === undefined) return false;
    if (!('hasOwnCheckingAccount' in value) || value['hasOwnCheckingAccount'] === undefined) return false;
    if (!('isCheckingAccountOverdrawn' in value) || value['isCheckingAccountOverdrawn'] === undefined) return false;
    if (!('hasRegisteredMobilePhone' in value) || value['hasRegisteredMobilePhone'] === undefined) return false;
    if (!('isElectricityInOwnName' in value) || value['isElectricityInOwnName'] === undefined) return false;
    if (!('isApartmentDistrictHeated' in value) || value['isApartmentDistrictHeated'] === undefined) return false;
    if (!('isDistrictHeatingInOwnName' in value) || value['isDistrictHeatingInOwnName'] === undefined) return false;
    if (!('lastChangedAtUtc' in value) || value['lastChangedAtUtc'] === undefined) return false;
    if (!('bankruptcyCapability' in value) || value['bankruptcyCapability'] === undefined) return false;
    return true;
}

export function BankruptcyChecklistResponseFromJSON(json: any): BankruptcyChecklistResponse {
    return BankruptcyChecklistResponseFromJSONTyped(json, false);
}

export function BankruptcyChecklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankruptcyChecklistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'hasRentArrears': json['hasRentArrears'],
        'hasUtilityArrears': json['hasUtilityArrears'],
        'hasOpenPenalties': json['hasOpenPenalties'],
        'hasInstallmentAgreement': json['hasInstallmentAgreement'],
        'canMeetInstallmentAgreement': json['canMeetInstallmentAgreement'],
        'hasChildrenWithMaintenance': json['hasChildrenWithMaintenance'],
        'paysFullMaintenance': json['paysFullMaintenance'],
        'isMaintenanceGarnished': json['isMaintenanceGarnished'],
        'wasPreviouslySelfEmployed': json['wasPreviouslySelfEmployed'],
        'isCurrentlySelfEmployed': json['isCurrentlySelfEmployed'],
        'hasBusinessLicense': json['hasBusinessLicense'],
        'exercisesTradeAsBusiness': json['exercisesTradeAsBusiness'],
        'isBusinessLicenseDormant': json['isBusinessLicenseDormant'],
        'hasMaintenanceArrears': json['hasMaintenanceArrears'],
        'hasCriminalDebts': json['hasCriminalDebts'],
        'hasCreditDebts': json['hasCreditDebts'],
        'creditWithinLastFiveYears': json['creditWithinLastFiveYears'],
        'creditRemark': json['creditRemark'],
        'hasMailOrderDebts': json['hasMailOrderDebts'],
        'mailOrderWithinLastThreeYears': json['mailOrderWithinLastThreeYears'],
        'mailOrderRemark': json['mailOrderRemark'],
        'hasNeverPaidDebts': json['hasNeverPaidDebts'],
        'hasOwnCheckingAccount': json['hasOwnCheckingAccount'],
        'isCheckingAccountOverdrawn': json['isCheckingAccountOverdrawn'],
        'hasRegisteredMobilePhone': json['hasRegisteredMobilePhone'],
        'isElectricityInOwnName': json['isElectricityInOwnName'],
        'isApartmentDistrictHeated': json['isApartmentDistrictHeated'],
        'isDistrictHeatingInOwnName': json['isDistrictHeatingInOwnName'],
        'lastChangedAtUtc': (json['lastChangedAtUtc'] == null ? null : new Date(json['lastChangedAtUtc'])),
        'bankruptcyCapability': BankruptcyCapabilityResponseFromJSON(json['bankruptcyCapability']),
    };
}

export function BankruptcyChecklistResponseToJSON(json: any): BankruptcyChecklistResponse {
    return BankruptcyChecklistResponseToJSONTyped(json, false);
}

export function BankruptcyChecklistResponseToJSONTyped(value?: BankruptcyChecklistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'hasRentArrears': value['hasRentArrears'],
        'hasUtilityArrears': value['hasUtilityArrears'],
        'hasOpenPenalties': value['hasOpenPenalties'],
        'hasInstallmentAgreement': value['hasInstallmentAgreement'],
        'canMeetInstallmentAgreement': value['canMeetInstallmentAgreement'],
        'hasChildrenWithMaintenance': value['hasChildrenWithMaintenance'],
        'paysFullMaintenance': value['paysFullMaintenance'],
        'isMaintenanceGarnished': value['isMaintenanceGarnished'],
        'wasPreviouslySelfEmployed': value['wasPreviouslySelfEmployed'],
        'isCurrentlySelfEmployed': value['isCurrentlySelfEmployed'],
        'hasBusinessLicense': value['hasBusinessLicense'],
        'exercisesTradeAsBusiness': value['exercisesTradeAsBusiness'],
        'isBusinessLicenseDormant': value['isBusinessLicenseDormant'],
        'hasMaintenanceArrears': value['hasMaintenanceArrears'],
        'hasCriminalDebts': value['hasCriminalDebts'],
        'hasCreditDebts': value['hasCreditDebts'],
        'creditWithinLastFiveYears': value['creditWithinLastFiveYears'],
        'creditRemark': value['creditRemark'],
        'hasMailOrderDebts': value['hasMailOrderDebts'],
        'mailOrderWithinLastThreeYears': value['mailOrderWithinLastThreeYears'],
        'mailOrderRemark': value['mailOrderRemark'],
        'hasNeverPaidDebts': value['hasNeverPaidDebts'],
        'hasOwnCheckingAccount': value['hasOwnCheckingAccount'],
        'isCheckingAccountOverdrawn': value['isCheckingAccountOverdrawn'],
        'hasRegisteredMobilePhone': value['hasRegisteredMobilePhone'],
        'isElectricityInOwnName': value['isElectricityInOwnName'],
        'isApartmentDistrictHeated': value['isApartmentDistrictHeated'],
        'isDistrictHeatingInOwnName': value['isDistrictHeatingInOwnName'],
        'lastChangedAtUtc': value['lastChangedAtUtc'] == null ? value['lastChangedAtUtc'] : value['lastChangedAtUtc'].toISOString(),
        'bankruptcyCapability': BankruptcyCapabilityResponseToJSON(value['bankruptcyCapability']),
    };
}

